import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import { HttpClient } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'brover-callback',
    template: '<brover-auth-loader></brover-auth-loader>',
    standalone: false
})
export class CallbackComponent {

  constructor(
    private localStorageService: LocalStorageService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private settingsService: AuthService,
    private router: Router) {
    this.activatedRoute.queryParams.subscribe(params => {
      const data = {
        grant_type: 'authorization_code',
        client_id: environment.client_id,
        code_verifier: this.localStorageService.get('code_challenge'),
        code: params['code'],
        redirect_uri: environment.redirectUri
      };

      if (params['state'] === this.localStorageService.get('state')) {
        this.http.post(`${environment.auth_api}auth/token`, data).subscribe((res: any) => {
          if (res.success === undefined) {
            this.localStorageService.set('access-token', `${res.token_type} ${res.access_token}`);
            this.localStorageService.set('refresh-token', `${res.token_type} ${res.refresh_token}`);
            this.settingsService.loadUser().then(() => {
              this.localStorageService.remove('state');
              this.localStorageService.remove('code_challenge');
              this.router.navigate(['/'], { queryParams: {}});
            });
          }
        });
      } else {
        this.router.navigate(['/'], { queryParams: {}});
      }
    });
  }
}
